<template>
  <el-dialog :visible.sync="visible" :close-on-click-modal="false">
    <template #title>
      <div class="title">
        <div class="title-main">
          Advertiser List
        </div>
        <div class="title-sub">
          {{ `&nbsp;- ${row.display_name}` }}
        </div>
      </div>
    </template>
    <div class="board">
      <el-tag
        v-for="(name, index) in row.advertisers_name"
        :key="index"
        type="info"
        class="tag"
      >
        {{ name }}
      </el-tag>
    </div>
    <div class="option">
      <el-button class="btn btn-form btn-blue option-cancel" @click="confirm">
        Confirm
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
export default {
  props: {
    row: Object,
  },
  computed: {
    visible: {
      get() {
        return this.$store.state.isDialogVisible;
      },
      set(value) {
        this.setVisible(value);
      },
    },
  },
  methods: {
    ...mapMutations({
      setVisible: "setDialogVisible",
    }),
    confirm() {
      this.setVisible(false);
    },
  },
};
</script>
<style scoped lang="sass">
.title
  display: flex
  font-weight: bold
  &-main
    color: $color-blue
    font-size: 28px
    padding-left: 15px
  &-sub
    font-size: 16px
    line-height: 32px
    color: $color-gray
    margin-left: 8px

.board
  border: 1px solid #F4F2F2
  border-radius: 5px
  min-height: 120px
  padding: 16px
  display: flex
  flex-wrap: wrap
.tag
  height: 24px
  line-height: 24px
  margin: 5px
.option
  display: flex
  justify-content: center
  &-cancel
    font-size: 16px
    margin-top: 24px
    height: 40px
    width: 180px
</style>
